import { Types } from "../actions/ToBePlannedActions";

const initialState = {
    toBePlannedList: {},
    recordStatusList: [],
    toBePlannedDetailById: {},
    isTaskUpdated: false,
};

export const ToBePlannedReducer = (state = initialState, action) => {
    switch (action.type) {
        case Types.SET_TOBEPLANNEDS:
            return {
                ...state,
                toBePlannedList: action.payload || state.toBePlannedList,
            };
        case Types.SET_RECORDSTATUSLIST:
            return {
                ...state,
                recordStatusList: action.payload || state.recordStatusList,
            };
        case Types.SET_TOBEPLANNED_DETAIL_BY_ID:
            return {
                ...state,
                toBePlannedDetailById: action.payload || state.toBePlannedDetailById,
            };
        case Types.IS_UPDATED_TASK:
            return {
                ...state,
                isTaskUpdated: true,
            };
        case Types.RESET_IS_UPDATED_TASK:
            return {
                ...state,
                isTaskUpdated: false,
            };
        default:
            return state;
    }
};
